import { render, staticRenderFns } from "./ExpertisePageDetails.vue?vue&type=template&id=8444d280&"
import script from "./ExpertisePageDetails.vue?vue&type=script&lang=ts&"
export * from "./ExpertisePageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8444d280')) {
      api.createRecord('8444d280', component.options)
    } else {
      api.reload('8444d280', component.options)
    }
    module.hot.accept("./ExpertisePageDetails.vue?vue&type=template&id=8444d280&", function () {
      api.rerender('8444d280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Expertises/ExpertisePageDetails.vue"
export default component.exports